module.exports = __webpack_public_path__ + "static/media/sun-fill.916ac6ad.svg";